import axios from '@/utils/axios';
import qs from 'qs';
import { CreateApp } from '@/apis/controll';
import { BaseResponse } from '@/type';
import { UserRoleType } from '@/type/enums';

interface WebBasic {
    appId: string;
    name: string;
    icon: string;
    desc: string;
    appRegistration: Array<any>;
}
// 修改移动应用基本信息
export async function updateWebBasic(options: WebBasic) {
    return await axios.post<CreateApp>(
        '/portal/app/web/updateBasicInfo',
        qs.stringify(options),
    );
}
interface WebOther {
    appId: string;
    website: string;
    webDownUrl: string;
    redirectUri: string;
}
// 修改移动应用额外信息
export async function updateWebExtra(options: WebOther) {
    return await axios.post<CreateApp>(
        '/portal/app/web/updateExtraInfo',
        qs.stringify(options),
    );
}

interface MobileBasic {
    appId: string;
    name: string;
    desc: string;
    website: string;
    icon: string;
    onStore: boolean;
}

// 修改移动应用基本信息
export async function updateMobileBasic(options: MobileBasic) {
    return await axios.post<CreateApp>(
        '/portal/app/mobile/updateBasicInfo',
        qs.stringify(options),
    );
}

// 修改移动应用额外信息
export async function updateMobileExtra(options: any) {
    return await axios.post<CreateApp>(
        '/portal/app/mobile/updateExtraInfo',
        qs.stringify(options),
    );
}

export async function getScopeSecurityPng(appId: string, scopeGroupId: number) {
    return await axios.post(
        `/portal/app/scope/extra/securityPng?appId=${appId}&scopeGroupId=${scopeGroupId}`,
    );
}

export async function applyCreateGame(options: any) {
    return await axios.post<CreateApp>(
        '/portal/app/miniGame/applyCreate',
        qs.stringify(options),
    );
}

export async function queryApplyCreateInfo(applyCreateId: string) {
    return await axios.get<Record<string, any>>(
        `/portal/app/miniGame/queryApplyCreateInfo?applyCreateId=${applyCreateId}`,
    );
}

export function getDebugUrl(launchLink: string) {
    return launchLink
        ? `http://ksurl.cn/createqrcode?${qs.stringify({
              content: launchLink,
              width: 104,
              height: 104,
              contentType: 'URL',
              toShortUrl: true,
          })}`
        : '';
}

interface APPNavbarItemType {
    name: string;
    type: number;
    desc: string;
}
interface APPNavbarType extends BaseResponse {
    navBarText: APPNavbarItemType[];
}
export async function getAPPNavbar() {
    const res = await axios.get<APPNavbarType>('/portal/account/navbar');
    return res.data.navBarText;
}

export async function applyGameCallbackUrl(
    callbackUrl: string,
    taskId: string,
    appId: string,
) {
    return await axios.post<
        BaseResponse & {
            data: {
                status: 0 | 1;
            };
        }
    >(
        '/portal/app/miniGame/updateCallbackUrl',
        qs.stringify({
            callbackUrl,
            taskId,
            appId,
        }),
    );
}

export async function queryGameCallbackUrl(appId: string) {
    return await axios.get<
        BaseResponse & {
            data: {
                callbackUrl: string;
            };
        }
    >(`/portal/app/miniGame/getCallbackUrl`, {
        params: {
            appId,
        },
    });
}

export interface UrlQuery {
    appId?: string;
    requestDomains?: string;
    socketDomains?: string;
    uploadFileDomains?: string;
    downloadFileDomains?: string;
    udpDomains?: string;
}
export async function checkGameUrl(url: UrlQuery) {
    return await axios.post<
        BaseResponse & {
            data: {
                domainNameVerifyResults: {
                    domainType: string;
                    index: number;
                    errorMsg: string;
                }[];
            };
        }
    >('/portal/app/miniGame/developConfig/submitTest', qs.stringify(url));
}

export async function queryUserInfoById(ksId: string, appId: string) {
    return await axios.get<
        BaseResponse & {
            userInfo: {
                status: 0 | 1; // 0:用户不存在，1用户状态正常
            };
        }
    >('/portal/user/isValid', {
        params: {
            appId,
            ksId,
        },
    });
}

export const accessType = {
    view: '可查看',
    edit: '可编辑',
    null: '无权限',
};

export const accessGroupMap = {
    base_info: '基本信息',
    version: '版本管理/备案管理',
    qualification: '资质信息',
    develop_config: '开发设置',
    advert: '广告位管理',
    data_center: '数据中心',
    contract: '合同管理',
    inside_pay: '内购参数管理',
    search_word: '搜索词管理',
    // self_checkout: '自助结算',
};

export type AccessGroup = {
    [K in keyof typeof accessGroupMap]: keyof typeof accessType;
};

export type Member = {
    userId: number;
    nickName: string;
    headUrl: string;
    roleType: 2 | 1; // 2:协作者，1管理员
    accessGroup: AccessGroup;
};

const adminAccessGroup: AccessGroup = {
    base_info: 'edit',
    version: 'edit',
    qualification: 'edit',
    develop_config: 'edit',
    advert: 'edit',
    data_center: 'edit',
    contract: 'edit',
    inside_pay: 'edit',
    search_word: 'edit',
    // self_checkout: 'edit',
};

export const fillAccessGroup = (
    it: Pick<Member, 'roleType' | 'accessGroup'>,
) => {
    if (it.roleType === UserRoleType.administrator) {
        return adminAccessGroup;
    }
    // 管理员默认填充 edit 协作者默认填充 null
    return Object.keys(accessGroupMap).reduce(
        (previousValue, currentValue) => ({
            ...previousValue,
            [currentValue]:
                it.accessGroup[currentValue as keyof AccessGroup] ?? 'null',
        }),
        {},
    ) as AccessGroup;
};

export async function queryUserInfoList(appId: string) {
    return await axios
        .get<
            BaseResponse & {
                memberList: Member[];
                remainingMember: number;
            }
        >('/portal/app/member/list', {
            params: {
                appId,
            },
        })
        .then((res) => {
            res.data.memberList.forEach((it) => {
                it.accessGroup = fillAccessGroup(it) as any;
            });
            return res;
        });
}

export interface QrcodeQuery {
    appId: string;
    memberId: number;
    operation: 'CREATE_MEMBER' | 'UPDATE_MEMBER' | 'DELETE_MEMBER';
    accessGroup?: AccessGroup;
}

export async function createQrCode(query: QrcodeQuery) {
    return await axios.post<
        BaseResponse & {
            infoToken: string;
        }
    >(
        '/portal/qrcode/token/create',
        qs.stringify({
            ...query,
            accessGroup: JSON.stringify(query.accessGroup),
        }),
    );
}

export async function addMember(query: {
    authToken: string;
    memberId: number;
    accessGroup: AccessGroup;
}) {
    return await axios.post<BaseResponse>(
        '/portal/app/member/create',
        qs.stringify(query),
    );
}

export async function updateMember(query: {
    authToken: string;
    memberId: number;
    accessGroup: AccessGroup;
}) {
    return await axios.post<BaseResponse>(
        '/portal/app/member/update',
        qs.stringify(query),
    );
}

export async function deleteMember(query: {
    authToken: string;
    memberId: number;
}) {
    return await axios.post<BaseResponse>(
        '/portal/app/member/delete',
        qs.stringify(query),
    );
}
